<template>
  <v-card>
    <v-toolbar dark color="darken-2" elevation="0" @short="true">
      <v-btn icon dark @click="fechar()">
        <v-icon>mdi-close</v-icon>
      </v-btn>
      <v-toolbar-title>
        <span v-if="isNovo">Novo Anuncio</span>
        <span v-else>Editar Anuncio</span>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-items>
        <v-btn dark text @click="salvarPublicacao()">Salvar</v-btn>
      </v-toolbar-items>
    </v-toolbar>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="5">
              <mb-text-field
                v-model="anuncio.titulo"
                prependIcon="work_outline"
                label="Anunciante" />
          </v-col>
          <v-col cols="7">
              <v-file-input
                small-chips
                multiple
                show-size
                counter
                label="Imagens"
                :rules="rules"
                color="black"
                v-model="imagemFile"
                @click:clear="limparImagem"
                @change="imageToBase64"></v-file-input>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="9">
            <mb-text-field
                v-model="anuncio.link"
                prependIcon="http"
                label="Link" />
          </v-col>
          <v-col cols="3">
            <mb-color-picker
              label="Cor da Publicação"
              v-model="anuncio.cor_fundo"/>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
</template>

<script>
import AnuncioInput from "@/classes/anuncioInput.js";
export default {
  props: ["isNovo", "setAnuncio"],
  data() {
    return {
      anuncio: new AnuncioInput(),

      imagemFile: [],
      rules: [
        value =>
          !value ||
          Object.values(value).reduce((t, {size}) => t + size, 0) < 2000000 ||
          "Imagem não pode ser maior que 2 MB!"
      ]
    }
  },
  mounted() {
  },
  methods: {
    salvarPublicacao() {
      if (this.$utils.isNull(this.anuncio.titulo)) {
        this.$toast.warning("Informe o nome do anunciante.");
        return;
      }
      if (this.$utils.isNull(this.anuncio.imagem)) {
        this.$toast.warning("Selecione uma imagem.");
        return;
      }
      if (this.$utils.isNull(this.anuncio.imagem)) {
        this.$toast.warning("Selecione uma imagem.");
        return;
      }

      this.$emit("salvar", this.anuncio);
    },
    getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = error => reject(error);
        });
    },
    imageToBase64() {
      this.imagemFile.forEach((image) => {
        this.getBase64(image)
          .then(data => {
            if (this.anuncio.imagem) {
              this.anuncio.imagem.push(data)
            } else {
              this.anuncio.imagem = [];
              this.anuncio.imagem.push(data)
            }
          }
        );
      });
    },
    limparImagem() {
      this.imagemFile = [];
      this.anuncio.imagem = [];
    },
    fechar() {
      this.$emit("fechar", false);
    },
  },
  components: {
  },
}
</script>

<style>
</style>
